import React from "react";
import { useCampaignList } from "../../hooks/useCampaignList";
import MainPageWrapper from "../../../../../../components/MainPageWrapper/MainPageWrapper";
import DataTable from "../../../../../../components/Datatable/Datatable";
import { Button } from "@/components/Button/Button";
import CampaignListFilters from "@/modules/stochastic/features/CampaignManagement/components/CampaignListFilters/CampaignListFilters";
import { Campaign } from "@/api/fetchCompanyCampaigns/types";

const CampaignList: React.FC = () => {
  const {
    campaigns,
    totalCount,
    loading,
    error,
    pagination,
    handlePageChange,
    handleCampaignStatusChange,
    campaignStatusId,
    sorting,
    handleSortingChange,
    columns,
    campaignStatuses,
    isImportInProgress,
    handleCreateCampaign,
  } = useCampaignList();

  return (
    <>
      <MainPageWrapper
        actions={
          <Button disabled={isImportInProgress} onClick={handleCreateCampaign}>
            Create Campaign
          </Button>
        }
        error={error}
        title="Campaigns"
      >
        {isImportInProgress && (
          <div className="mb-4 border-l-4 border-yellow-400 bg-yellow-50 dark:bg-yellow-900/20 p-4">
            <p className="text-sm text-yellow-800 dark:text-yellow-300">
              Campaign creation is disabled while company data is still being
              imported.
            </p>
          </div>
        )}

        <CampaignListFilters
          campaignStatusId={campaignStatusId}
          campaignStatuses={campaignStatuses}
          onFilterChange={handleCampaignStatusChange}
        />

        <DataTable<Campaign>
          columns={columns}
          data={campaigns}
          error={error}
          loading={loading}
          noDataMessage="No campaigns found"
          onPageChange={handlePageChange}
          onSortingChange={handleSortingChange}
          pageIndex={pagination.pageIndex}
          pageSize={pagination.pageSize}
          rowKeyExtractor={(campaign) => campaign.id}
          sorting={sorting}
          totalCount={totalCount}
        />
      </MainPageWrapper>
    </>
  );
};

export default CampaignList;
